import styled from 'styled-components'
import CloseIcon from '@material-ui/icons/Close';
import {Link} from 'react-router-dom'

export const NewsSavedList = styled.ul`
    width: 100%;
    list-style: none;
    min-height: 50vh;
`

export const NewsSavedItem = styled.li`
    padding: 12px 0 12px 42px;
    border-top: 1px solid #e9e9e9;
    background-color: #fbfbfb;
    display: flex;
    align-items: center;

    @media screen and (max-width: 767px) {
        padding-left: 8px !important;
    }
`

export const NewsSavedTitle = styled(Link)`
    width: 500px;
    font-size: 14px;
    color: #222;
    font-weight: bold;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media screen and (max-width: 767px) {
        font-size: 16px;
        line-height: 22px;
        width: 70%;
        white-space: normal;
    }
`

export const NewsSavedCreatedAt = styled.span`
    color: #222;
    font-size: 12px;
    margin-left: 12px;

    @media screen and (max-width: 767px) {
        margin-right: 8px;
    }
`

export const NewsSavedRemove = styled(CloseIcon)`
    color: #333;
    margin-left: auto;
    cursor: pointer;
    font-size: 20px;
    margin-right: 20px;

    @media screen and (max-width: 767px) {
        margin-right: 8px;
    }
`

export const EmptyNews = styled.h2`
    color: #333;
    font-size: 16px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 150px;
`